export const ENABLE_HARDCODED_PRODUCT = false;

export const booking_meta_title = "Book tid ved Skorstensgaard her"
export const booking_meta_desc = ""
export const offer_meta_title = "Få tilbud på din reparation ved Skorstensgaard her"
export const offer_meta_desc = ""

export const repair_step_name = "reparationer"
export const repair_step_heading = "Vælg reparationer";

export const upsale_step_name = "rabatter"
export const upsale_step_heading = "Få rabat på disse tilvalg";
export const upsale_step_secondary_heading = "Når vi alligevel har din bil på liften, kan vi tilbyde dig ekstra gode tilbud på følgende reparationer og produkter";

export const location_step_name = "afdeling"
export const location_step_heading = "Vælg afdeling";
export const location_geolocation_button_text = "Brug lokation";

export const date_step_name = "tid&dato"
export const date_step_heading = "Book din tid her";
export const date_step_secondary_heading_part_one = "Vi har valgt den første ledige tid for dig i" //the name of the selectedShop will be appended -> Vi har valgt den første ledige tid for dig i Aalborg
export const date_step_secondary_heading_part_two = "Du kan ændre datoen ved at vælge en anden dato i kalenderen herunder"
export const date_step_scroll_to_close_shops = "Se andre afdelinger i nærheden af dig"
export const date_step_rental_car_check_text = "Lånebil (Hvis muligt)"
export const date_step_closest_shops_heading = "Se næste ledige dato for andre afdelinger"
export const date_step_closest_shops_secondary_heading = "Kunne du ikke finde en ledig dato i denne afdeling, som passer dig"
export const date_step_delivery_in_closed_hours = "Indlever udenfor åbningstid"
export const date_step_delivery_in_closed_hours_description = "Skal være indleveret ved dagens start"
export const date_step_delivery_in_closed_hours_helper_title = "Indlevere du bilen udenfor vores åbningstid?"
export const date_step_delivery_in_closed_hours_helper_text = "Når denne mulighed er valgt, så forventer vi at du indlevere din bil udenfor åbningstiden, lægger nøglen i nøgle-postkassen, således vi har din bil når vi åbner den valgte dato."
export const date_step_all_day = "Bilen er på værksted hele dagen"
export const date_step_all_day_description = "fra kl." //opening hour and closing hour will be appended -> fra kl. 7.30 til 16.30
export const date_step_waiting = "Jeg venter imens"
export const date_step_waiting_description = ""
export const date_step_waiting_helper_title = "Ønsker du at vente imens din bil er på værksted ?"
export const date_step_waiting_helper_text = "Hvis denne mulighed er valgt, så forventer vi at du venter i vores venterum i mens din bil er på værkstedet, Bilen skal indleveres, så vi har bilen på det valgte tidspunkt."

export const info_step_name = "mine info"
export const info_step_heading = "Kontrollér venligst dine valg og indtastninger"
export const info_step_description = "Inden vi sender din forespørgsel til vores eksperter, \nvil vi lige bede dig om at kontrollere dine valg først og sikre at vi har de korrekte kontakt oplysninger på dig."
export const info_step_plate_field_title = "Registreringsnr."
export const info_step_plate_field_placeholder = "AB12345"
export const info_step_odometer_field_title = "Kilometerstand"
export const info_step_odometer_field_placeholder = "123456"
export const info_step_name_field_title = "Fulde navn *"
export const info_step_name_field_placeholder = "Jens Jensen"
export const info_step_email_field_title = "Indtast email *"
export const info_step_email_field_placeholder = "jens123@mail.dk"
export const info_step_countrycode_field_title = "Landekode *"
export const info_step_countrycode_field_placeholder = "+45"
export const info_step_phone_field_title = "Indtast mobilnr. *"
export const info_step_phone_field_placeholder = "21222324"
export const info_step_postal_field_title = "Postnr."
export const info_step_postal_field_placeholder = "6000"
export const info_step_city_field_title = "Bynavn"
export const info_step_city_field_placeholder = "Kolding"
export const info_step_comment_field_title = "Kommentar"
export const info_step_comment_field_placeholder = "Jeg vil gerne have.."
export const info_step_newsletter_title = "Ja tak, jeg vil gerne modtage markedsføring af biler, tilbehør og vedligehold heraf, samt af brandet, finansiering og forsikring. Skorstensgaard Danmark A/S må kontakte mig via e-mail. Samtykket kan til enhver tid tilbagekaldes ved at kontakte Skorstensgaard Danmark A/S. Du kan læse mere om vores behandling af dine personoplysninger og vores brug af tilpasset markedsføring i vores privatlivspolitik."
export const info_step_newsletter_desc = ""